const automations = {
  pageName: 'Automations',
  btnCreate: 'Create',
  btnUseTemplate: 'Use template',
  mainTabs: {
    titleAutomationsCenter: 'Automations Center',
    titleAutomationsExisting: 'Existing Automations',
  },
  deleteModal: {
    header: 'Delete Automations',
    body: 'You are about to delete {{num}} automations.',
    success: 'Automations were successfully deleted',
  },
  table: {
    header: {
      name: 'Name',
      nextRun: 'Next Run',
      lastRun: 'Last Run',
      createdAt: 'Date Created',
      createdBy: 'Created by',
      actionType: 'Action Type',
      status: 'Status',
      profiles: 'Profiles',
      suppliers: 'Suppliers',
      attributes: 'Attributes',
      areas: 'Zones',
      locations: 'Locations',
      airports: 'Airports',
      run: 'Run',
    },
    filters: {
      status: {
        title: 'Status',
        options: {
          on: 'On',
          off: 'Off',
        },
      },
      profiles: {
        title: 'Profiles',
      },
      suppliers: {
        title: 'Suppliers',
      },
      attributes: {
        title: 'Attributes',
      },
      areas: {
        title: 'Zones',
      },
      locations: {
        title: 'Locations',
      },
      airports: {
        title: 'Airports',
      },
      actionType: {
        title: 'Action Type',
        options: {
          routingProcess: 'Routing Process',
          busRoute: 'Bus Route',
          driverAssignment: 'Driver Assignment',
        },
      },
    },
    actions: {
      run: 'Run Now',
      duplicate: {
        title: 'Duplicate',
      },
      delete: {
        title: 'Delete',
      },
    },
    toasts: {
      delete: {
        success: 'Deleted Successfully!',
        error: 'Error Occurred! Could Not Delete Zone',
      },
      run: {
        success: 'Automation queued. It will run shortly',
        error: 'Error occurred! Could not run automation',
      },
    },
  },
  wizard: {
    titleCreate: 'Create',
    titleUpdate: 'Update',
    trigger: {
      title: '1.Trigger',
      subTitle: 'A trigger is an event that starts your automation',
      loadingText: 'Please wait loading parameters.',
      selectTrigger: {
        label: 'Trigger',
      },
      btnContinue: 'Continue',
    },
    action: {
      title: '2.Action',
      subTitle: 'An action is an event performs after it starts',
      loadingText: 'Please wait loading parameters.',
      selectAction: {
        label: 'Action',
      },
      btnContinue: 'Continue',
    },
    information: {
      title: '3.Information',
      subTitle: 'Common information about the automation',
      name: 'Automation Name',
      description: 'Description',
      profile: 'Profile',
      supplier: 'Supplier',
      attributes: 'Attributes',
      areas: 'Zone',
      locations: 'Locations',
      airports: 'Airport Locations',
      btnSubmit: 'Submit',
    },
  },
  automationsCenter: {
    tabs: {
      all: 'All',
      routingProcess: 'Routing Process',
      busRoute: 'Bus Route',
      driverAssignment: 'Driver Assignment',
    },
  },
  toasts: {
    error: 'Something went Wrong',
    successCreated: 'Successfully created',
    successUpdated: 'Successfully updated',
  },
};

export default automations;
